import React from 'react';
import {
  addPathToList,
  getSubCategoryId,
  Select_fields_appear,
  transaction_fee_paid,
  Transfer_confirmation,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';

//= ========================================================================
const Panel_B10_SendMoneyConfirmation = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'does_it_look_ok',
    'transaction_fee_is_on_the_recipient',
    'confirm',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { confirmation } = globJSON.configurations.services[subCategoryId];
  const onValueChanged = (key, value) => {
    confirmation[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Transfer_confirmation}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/confirmation/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={Select_fields_appear}
      language={language}
    >
      <SwitcherPanel
        text={transaction_fee_paid}
        value={confirmation.enable_transaction_fee_on_the_recipient}
        onValueChanged={(value) => {
          onValueChanged('enable_transaction_fee_on_the_recipient', value);
        }}
      />
    </FullPagePanel>
  );
};

export default Panel_B10_SendMoneyConfirmation;
